import { useEffect, useMemo, useState } from "react";
import { IoMdClose } from "react-icons/io";

const DISMISS_KEY = "maintenance_dismissed_until";

export default function MaintenanceBanner({ from, to, onDismiss }) {
    const [visible, setVisible] = useState(false);
    const [startsIn, setStartsIn] = useState("");

    const fromDate = useMemo(() => new Date(from), [from]);
    const toDate = useMemo(() => new Date(to), [to]);

    function fmtDate(d) {
        return (
            d.toLocaleDateString("en-IN", { weekday: "short", month: "short", day: "numeric" }) +
            " · " +
            d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false })
        );
    }

    useEffect(() => {
        const now = new Date();
        const timeLeft = fromDate - now;                    // maintenance shuru hone mein kitna time
        const last30mins = timeLeft <= 30 * 60 * 1000;       // last 30 min mein hai?

        if (last30mins) {
            // Last 30 min — dismiss ignore karo, hamesha dikhao
            localStorage.removeItem(DISMISS_KEY);
            setVisible(true);
        } else {
            // Check karo kya pehle dismiss kiya tha
            const dismissedUntil = localStorage.getItem(DISMISS_KEY);
            if (dismissedUntil && now < new Date(dismissedUntil)) {
                // Abhi 30 min nahi gaye — mat dikhao
                setVisible(false);
            } else {
                setVisible(true);
            }
        }
    }, [fromDate]);

    useEffect(() => {
        if (!visible) return;
        function tick() {
            const diff = fromDate - new Date();
            if (diff <= 0) { setStartsIn("Live now"); return; }
            const h = Math.floor(diff / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            setStartsIn(h > 0 ? `Starts in ${h}h ${m}m` : `Starts in ${m}m`);
        }
        tick();
        const id = setInterval(tick, 30000);
        return () => clearInterval(id);
    }, [visible, fromDate]);

    function handleDismiss() {
        const now = new Date();
        const timeLeft = fromDate - now;
        const last30 = timeLeft <= 30 * 60 * 1000;

        if (!last30) {
            // 30 min baad tak dismiss store karo
            const until = new Date(now.getTime() + 30 * 60 * 1000);
            localStorage.setItem(DISMISS_KEY, until.toISOString());
        }
        // last 30 min mein dismiss ka button kaam nahi karega (visible rahega)
        setVisible(false);
        onDismiss?.();
    }

    if (!visible) return null;

    const timeLeft = fromDate - new Date();
    const last30mins = timeLeft <= 30 * 60 * 1000;

    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "rgb(255, 247, 237)",
            border: "1px solid rgb(253, 186, 116)",
            borderRadius: 8,
            padding: "10px 16px",
            gap: 12,
            zIndex: 9999,
            width: "50%",
            margin: "auto",
            position: "absolute",
            left: 0,
            right: 0,
            top: 7,
        }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1, minWidth: 0 }}>
                <div style={{
                    width: 8, height: 8, borderRadius: "50%",
                    background: "#ea580c", flexShrink: 0,
                }} />
                <div>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#9a3412", display: "block" }}>
                        Scheduled Maintenance
                    </span>
                    <span style={{ fontSize: 12, color: "#c2410c" }}>
                        System will be unavailable from{" "}
                        <strong style={{ color: "#9a3412" }}>{fmtDate(fromDate)}</strong>
                        {" "}to{" "}
                        <strong style={{ color: "#9a3412" }}>{fmtDate(toDate)}</strong>
                    </span>
                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
                <div style={{
                    background: "#fed7aa", borderRadius: 6, padding: "4px 10px",
                    fontSize: 12, fontWeight: 700, color: "#9a3412", whiteSpace: "nowrap",
                }}>
                    {startsIn}
                </div>

                {/* Last 30 min mein × button hide karo */}
                {!last30mins && (
                    <button
                        onClick={handleDismiss}
                        style={{
                            background: "none", border: "none", cursor: "pointer",
                            fontSize: 20, color: "#9a3412", lineHeight: 1, padding: 0,
                        }}
                        aria-label="Dismiss"
                    ><IoMdClose size={20} /></button>
                )}
            </div>
        </div>
    );
}